import { Phone, Mail } from "lucide-react";
import { BUSINESS, LOGO_URL } from "@/lib/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-forest text-cream">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 lg:py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-cream rounded-2xl inline-flex p-3 mb-6">
              <img src={LOGO_URL} alt={BUSINESS.fullName} className="h-14 w-auto" />
            </div>
            <h2 className="font-heading text-3xl sm:text-4xl font-extrabold leading-tight max-w-md">
              Ready to keep your property looking its best?
            </h2>
            <p className="mt-4 text-cream/70 max-w-md">{BUSINESS.blurb}</p>
          </div>

          <div className="lg:justify-items-end">
            <div>
              <h3 className="text-xs tracking-[0.2em] uppercase text-lawn-light font-bold mb-4">
                Get in touch
              </h3>
              <a href={`tel:${BUSINESS.phoneRaw}`} data-testid="footer-phone" className="flex items-center gap-3 py-2 text-lg font-semibold hover:text-lawn-light transition-colors">
                <Phone className="w-5 h-5" /> {BUSINESS.phone}
              </a>
              <a href={`mailto:${BUSINESS.email}`} data-testid="footer-email" className="flex items-center gap-3 py-2 text-sm sm:text-base font-medium text-cream/80 hover:text-lawn-light transition-colors break-all">
                <Mail className="w-5 h-5 shrink-0" /> {BUSINESS.email}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-cream/15 flex flex-col sm:flex-row gap-2 justify-between text-sm text-cream/60">
          <p>© {new Date().getFullYear()} {BUSINESS.fullName}. All rights reserved.</p>
          <p>Reliable lawn & property care.</p>
        </div>
      </div>
    </footer>
  );
};
